import React, { createContext, useEffect, useState } from 'react';
import { subscribeToAuth } from '../auth';

export const UserContext = createContext(null);

export function UserProvider({ children }) {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const unsubscribe = subscribeToAuth((authUser) => {
            setUser(authUser);
        });
        return () => unsubscribe();
    }, []);

    return (
        <UserContext.Provider value={user}>
            {children}
        </UserContext.Provider>
    );
}
